import { render, staticRenderFns } from "./BInputGroupFormSwitch.vue?vue&type=template&id=70c02c86&scoped=true&"
import script from "./BInputGroupFormSwitch.vue?vue&type=script&lang=js&"
export * from "./BInputGroupFormSwitch.vue?vue&type=script&lang=js&"
import style0 from "./BInputGroupFormSwitch.vue?vue&type=style&index=0&id=70c02c86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c02c86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70c02c86')) {
      api.createRecord('70c02c86', component.options)
    } else {
      api.reload('70c02c86', component.options)
    }
    module.hot.accept("./BInputGroupFormSwitch.vue?vue&type=template&id=70c02c86&scoped=true&", function () {
      api.rerender('70c02c86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/forms/BInputGroupFormSwitch.vue"
export default component.exports